import { jsx as _jsx } from "react/jsx-runtime";
import { m } from 'framer-motion';
export function ClusterMotionAnimation({ children }) {
    return (_jsx(m.div, { initial: { scale: 0.75, opacity: 0 }, animate: {
            scale: [0.75, 1.3, 0.9, 1],
            opacity: [0, 1, 1, 1],
        }, exit: { scale: 0.75, opacity: 0 }, transition: {
            duration: 0.55,
            ease: 'easeOut',
        }, children: children }));
}
